import { render, staticRenderFns } from "./newsletterSignupBlock.vue?vue&type=template&id=27f7ad70&scoped=true"
import script from "./newsletterSignupBlock.vue?vue&type=script&lang=js"
export * from "./newsletterSignupBlock.vue?vue&type=script&lang=js"
import style0 from "./newsletterSignupBlock.vue?vue&type=style&index=0&id=27f7ad70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7ad70",
  null
  
)

export default component.exports